
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentAccount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hwHubs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"id"}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"internalName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fwUploadInterval"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fwDownloadInterval"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fwDownloadDuration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fwScaleInterval"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fwWeightTriggerThreshold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fwTemperatureTriggerThreshold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fwHumidityTriggerThreshold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activeSite"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"recentMetrics"},"name":{"kind":"Name","value":"nrfMetrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"past"},"value":{"kind":"StringValue","value":"8h","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voltage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gsmSignal"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"activeHwSensors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"internalName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activeMetrics"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activeHive"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"recentMetrics"},"name":{"kind":"Name","value":"nrfMetrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"past"},"value":{"kind":"StringValue","value":"8h","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"voltage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dhtHum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dhtTemp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"weight"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":964}};
    doc.loc.source = {"body":"query getHub($id: ID!) {\n  currentAccount {\n    id\n    hwHubs(ids: [$id]) {\n      nodes {\n        id\n        internalName\n        serialNumber\n\n        fwUploadInterval\n        fwDownloadInterval\n        fwDownloadDuration\n        fwScaleInterval\n        fwWeightTriggerThreshold\n        fwTemperatureTriggerThreshold\n        fwHumidityTriggerThreshold\n\n        activeSite {\n          id\n          name\n        }\n\n        recentMetrics: nrfMetrics(past:\"8h\") {\n          voltage\n          time\n          gsmSignal\n        }\n\n        activeHwSensors {\n\t\t\t\t\tnodes {\n            id\n            serialNumber\n            internalName\n            activeMetrics\n\n            activeHive {\n              id\n              name\n            }\n            recentMetrics: nrfMetrics(past:\"8h\") {\n              time\n              voltage\n              dhtHum\n              dhtTemp\n              weight\n            }\n          }\n          totalCount\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getHub"] = oneQuery(doc, "getHub");
        
